export default __webpack_public_path__ + "static/media/logo.af8ec448.png";